module.exports = __webpack_public_path__ + "static/media/banner-roi.781ad472.jpg";